import React from 'react'

import {Helmet} from "react-helmet";

// SECTIONS
import SectionHome from './SectionHome'

import PageAnalytics from '../../components/PageAnalytics'

const Page = (props) => {
  return (
    <div>

      {/* Html header */}
      <Helmet>
        <title>Santander Alpha Support</title>
      </Helmet>

      {/* Analytics */}
      <PageAnalytics title='Santander Alpha Support'/>

      <SectionHome />
    </div>
  )
}


export default Page




// WEBPACK FOOTER //
// ./src/pages/Home/index.js